"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var misc_utils_of_mine_generic_1 = require("misc-utils-of-mine-generic");
var util_1 = require("util");
var BrowserBuffer = require('buffer/').Buffer;
exports.BufferClass = misc_utils_of_mine_generic_1.isNode() ? Buffer : BrowserBuffer;
// export function getBufferClass(){
//   return isNode() ? Buffer : BrowserBuffer
// }
var blobToBufferFn = require('blob-to-buffer');
exports.blobToBuffer = util_1.promisify(blobToBufferFn);
exports.typedArrayToBuffer = require('typedarray-to-buffer');
// var arr = new Uint8Array([1, 2, 3])
// arr = typedArrayToBuggert(arr)
//# sourceMappingURL=buffer.js.map